import FAQ from "@/components/TopTen/FAQ";
import AirBannerInfo from "@/components/TopTen/AirBannerInfo";
import AirBannerContent from "@/components/TopTen/AirBannerContent";

import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import {
  BannerAirConditionDescription,
  InfoAirConditions,
  TopTenFAQ,
  TopTenSeo,
} from "@/constants/TopTen";
import { useTranslation } from "next-i18next";
import { getProductsBySkuV2 } from "@/services/elasticsearch/getProducts";
import SEO from "@/components/seo";
import { handshakeCookieName } from "@/constants";
import { buildCanonicalUrl } from "@/utils/canonical";
import { localeHandShake } from "@/services/token/handshake";

const Index = ({ products: myProducts, isMobile }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation("common");
  const products = myProducts.map((info) => (info === null ? [] : info?.data));
  return (
    <>
      <SEO
        title={TopTenSeo.air_condition[`title_${language}`]}
        description={TopTenSeo.air_condition[`description_${language}`]}
      >
        <link
          rel="canonical"
          href={buildCanonicalUrl("/top-ten/air-conditions", language)}
        />
      </SEO>
      <section className="w-[80%] max-[768px]:w-[98%] mx-auto my-4 max-[768px]:my-1 bg-white p-2 rounded-md">
        <AirBannerContent
          title={
            language === "en"
              ? `Discover the 10 Best Performing Split Air Conditioners in Saudi Arabia`
              : "اكتشف أفضل ١٠ مكيفات سبليت ذات الأداء العالي في المملكة العربية السعودية"
          }
          content={BannerAirConditionDescription[language]}
        />
        {InfoAirConditions.map((info, key) => (
          <AirBannerInfo
            t={t}
            key={key}
            data={info}
            language={language}
            products={products[key]}
            isMobile={isMobile}
          />
        ))}
        <FAQ
          title={
            language === "en"
              ? "Frequently asked questions about split air conditioners"
              : "أسئلة شائعة عن مكيفات سبليت"
          }
          language={language}
          data={TopTenFAQ}
        />
      </section>
    </>
  );
};

export default Index;

export async function getServerSideProps({ locale, req, res }) {
  const handshake =
    req.cookies[handshakeCookieName(locale)] ||
    (await localeHandShake(locale, { req, res }))?.data?.token;
  const products = await Promise.all([
    getProductsBySkuV2(
      ["110300101318020", "110300302318009", "110300402318006"],
      handshake
    ),
    getProductsBySkuV2(
      [
        "110300101312017",
        "110300301312009",
        "110300401312005",
        "110300102312016",
      ],
      handshake
    ),
    getProductsBySkuV2(
      ["110300101324025", "110300401324006", "110300302324007"],
      handshake
    ),
    getProductsBySkuV2(
      // Best Samsung Split Air Conditioners
      ["110300502318004", "110300502324002", "110300502324004"],
      handshake
    ),
    getProductsBySkuV2(
      [
        "110300702318021",
        "110300702324022",
        "110300702318020",
        "110300701318019",
      ],
      handshake
    ),
    getProductsBySkuV2(
      ["110304101312003", "110304101318006", "110304101324009"],
      handshake
    ),
    getProductsBySkuV2(["110300101318020", "110300101330011"], handshake),
    getProductsBySkuV2(["110302901324002", "110302901318003"], handshake),
  ]);

  const userAgent = req.headers["user-agent"] || "";
  const isMobile =
    /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/i.test(
      userAgent
    );
  return {
    props: {
      products,
      isMobile,
      ...(await serverSideTranslations(locale, ["common"])),
    },
  };
}
